<template>
  <div class="modal fade" id="modalRefunds" role="dialog">
    <div class="modal-dialog modal-dialog-35" v-bind:style="{'width': width}">
      <!-- Modal content-->
      <div class="modal-content modal-refunds modal-global">
        <div class="modal-body">
          <div class="content-title">
            <h5 v-if="isCreate" class="modal-title modal-title1"><span class="certa">Solicitar reembolso</span></h5>
            <h5 v-if="isDetail" class="modal-title modal-title1"><span class="certa">Detalhes do Reembolso</span></h5>
          </div>
          <button type="button" class="close" v-on:click="closeModalHeader()" data-dismiss="modal">&times;</button>
          <div v-if="loading">
            <progress-loading :additionalBoxStyle="'margin-top: 20px; min-height: 45px;'" :additionalLineStyle="'height: 20px'"/>
            <progress-loading :additionalBoxStyle="'min-height: 45px;'" :additionalLineStyle="'height: 20px'"/>
            <progress-loading :additionalBoxStyle="'min-height: 45px;'" :additionalLineStyle="'height: 20px'"/>
            <progress-loading :additionalBoxStyle="'min-height: 45px;'" :additionalLineStyle="'height: 20px'"/>
            <progress-loading :additionalBoxStyle="'min-height: 45px;'" :additionalLineStyle="'height: 20px'"/>
            <progress-loading :additionalBoxStyle="'min-height: 45px;'" :additionalLineStyle="'height: 20px'"/>
            <progress-loading :additionalBoxStyle="'min-height: 45px;'" :additionalLineStyle="'height: 20px'"/>
          </div>
          <div v-if="isCreate" class="row is-solicitation">
            <div class="col-sm-12 col-md-12 col-lg-12 mb-2">
              <h6>Detalhes do reembolso</h6>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 content-solicitation" style="margin-bottom: 10px">
              <label>Data da despesa <span>*</span></label>
              <datepicker v-model="requestRefundForm.refundDate" placeholder="teste" :language="ptBR" :format="customFormatter"/>
              <svg class="refund-date" width="24" height="24" viewBox="0 0 24 24">
                <path class="a" d="M20,3H19V1H17V3H7V1H5V3H4A2.006,2.006,0,0,0,2,5V21a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,20,3Zm0,18H4V8H20Z"/>
              </svg>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 content-solicitation" style="margin-bottom: 10px">
              <label>Valor <span>*</span></label>
              <input v-model.lazy="requestRefundForm.refundValue" v-money="money" maxlength="10"/>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 content-solicitation" style="margin-bottom: 10px">
              <label>Categoria da despesa <span>*</span></label>
              <select v-model="requestRefundForm.refundCategory" @change="changeDescriptionCategory">
                <option value="">Selecione</option>
                <option v-for="a in categories" :value="a.id">{{ a.name }}</option>
              </select>
              <label v-if="this.descriptionCategory !== ''" style="margin-top: 5px">{{ this.descriptionCategory.description }}</label>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 content-solicitation">
              <label>Observação</label>
              <textarea v-model="requestRefundForm.refundObs" maxlength="244" placeholder="Digite aqui"></textarea>
              <span class="count-txtarea">{{ requestRefundForm.refundObs.length }}/244</span>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12" style="margin-bottom: 30px">
              <h6>Anexos:</h6>
              <div v-for="(a, index) in totalAttachments" class="content-solicitation">
                <div class="input-group">
                  <p class="nunito">Anexar comprovante <span>*</span></p>
                  <div class="file-group">
                    <input :disabled="uploadStage[index].status === 'success'" type="file" :id="'documentFileRefunds' + index" ref="myFiles" class="custom-file-input" @change="previewFiles(index)" style="display: none">
                    <input v-model="attachments[index].name" class="form-control" @click="attachFile('#documentFileRefunds' + index)" placeholder="Selecione o arquivo" type="text" name="document" readonly="readonly" style="cursor: pointer;">
                    <img v-if="uploadStage[index].status === 'success'" src="../../../assets/img/conf_send.png" class="status-file" height="22" width="22">
                    <img v-if="uploadStage[index].status === 'fail'" src="../../../assets/img/fail_send.png" class="status-file" height="22" width="22">
                    <div v-if="uploadStage[index].status === 'loading'" class="loading-file">
                      <span><i class="glyphicon glyphicon-repeat spinning"></i></span>
                    </div>
                    <span @click="attachFile('#documentFileRefunds' + index)" class="input-group-btn">Selecionar</span>
                    <span @click="removeInputAttach(index)" class="certa remove-file"><ion-icon name="remove-circle-outline"></ion-icon>Remover</span>
                  </div>
                </div>
              </div>
              <div v-if="this.totalCountAttachments < 4" class="add-attach">
                <span v-on:click="addInputAttach()"><ion-icon name="add-circle-outline"></ion-icon>Adicionar anexo</span>
              </div>
            </div>
            <div class="double-btn">
              <span v-if="validateForm" class="form-error">Preencha todos os campos com *</span>
              <button v-on:click="closeModal()" type="button" class="nunito close-btn">Fechar</button>
              <button :disabled="loadingSolicitation" v-on:click="requestNewRefund()" type="submit" class="nunito btn-submit">
                <span v-if="!loadingSolicitation">Enviar Solicitação</span>
                <div class="loading-btn" v-else>
                  <div class="spinner-btn">
                    <div class="rect1"></div>
                    <div class="rect2"></div>
                    <div class="rect3"></div>
                    <div class="rect4"></div>
                    <div class="rect5"></div>
                  </div>
                </div>
              </button>
            </div>
          </div>
          <div v-if="isDetail && !$props.solicitationTeam && !loading" class="row is-solicitation-view">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <div class="solicitation-user">
                <img v-if="dataContentRefundsEmployee[0].photoUri !== null || ''" :src="dataContentRefundsEmployee[0].photoUri" alt="Foto" />
                <img v-else src="../../../assets/img/user-default.png" alt="Foto" />
                <span class="name">{{ dataContentRefundsEmployee[0].name }}</span>
                <span class="office">{{ dataContentRefundsEmployee[0].officeName }}</span>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
              <div class="solicitation-status">
                <span class="title">Detalhes do reembolso</span>
                <span class="value">Valor: <span>{{ dataContentRefundsEmployee[0].value | formatMoney }}</span></span>
                <span class="status">Status:</span>
                <span v-if="dataContentRefundsEmployee[0].userRefundStatus === 0" class="tag-uninformed">Não informado</span>
                <span v-if="dataContentRefundsEmployee[0].userRefundStatus === 1" class="tag-pending">Pendente</span>
                <span v-if="dataContentRefundsEmployee[0].userRefundStatus === 4" class="tag-analysis">Em análise</span>
                <span v-if="dataContentRefundsEmployee[0].userRefundStatus === 2" class="tag-approved">Aprovado</span>
                <span v-if="dataContentRefundsEmployee[0].userRefundStatus === 3" class="tag-refused">Recusado</span>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12">
              <div class="solicitation-details">
                <span class="title">Detalhes do Reembolso</span>
                <span class="requested">Solicitado em: <span>{{ dataContentRefundsEmployee[0].requestedAt | formatDate }}</span></span>
                <span class="expense">Data da despesa: <span>{{ dataContentRefundsEmployee[0].expenseDate | formatDate }}</span> </span>
                <span class="value">Valor: <span>{{ dataContentRefundsEmployee[0].value | formatMoney }}</span></span>
                <span class="category">Categoria: <span>{{ dataContentRefundsEmployee[0].refundCategory }}</span></span>
                <span class="obs">Observação: <span>{{ dataContentRefundsEmployee[0].message }}</span></span>
                <span v-if="dataContentRefundsEmployee[0].userRefundStatus === 3" class="obs">Motivo da recusa: <span>{{ dataContentRefundsEmployee[0].deniedMotive }}</span></span>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12">
              <div class="solicitation-attachments">
                <span class="title">Anexos:</span>
                <svg class="d-none" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.8334 7.5H12.5V2.5H7.50004V7.5H4.16671L10 14.1667L15.8334 7.5ZM3.33337 15.8333H16.6667V17.5H3.33337V15.8333Z" fill="#2F23D6"/>
                </svg>
                <div class="attachments">
                  <div v-for="(value, index) in dataContentRefundsEmployee[0].attachments" class="group-attachments" :key="index">
                    <a v-if="value.type === 0" :href="value.uri" target="_blank">
                      <img  class="attachment-img" :src="value.uri" alt="Anexo"/>
                    </a>
                    <a v-if="value.type === 1" :href="value.uri" target="_blank">
                      <img  class="attachment-img" :src="value.uri" alt="Anexo"/>
                    </a>
                    <div @click="openDocument(value.uri)" v-if="value.type === 2" class="attachment-archive attachment-pdf">
                      <span>Arquivo PDF</span>
                      <a :href="value.uri" target="_blank">Visualizar</a>
                    </div>
                    <div @click="openDocument(value.uri)" v-if="value.type === 3" class="attachment-archive attachment-doc">
                      <span>Documento</span>
                      <a :href="value.uri" target="_blank">Visualizar</a>
                    </div>
                    <div @click="openDocument(value.uri)" v-if="value.type === 4" class="attachment-archive attachment-zip">
                      <span>Arquivo ZIP</span>
                      <a :href="value.uri" target="_blank">Visualizar</a>
                    </div>
                    <div @click="openDocument(value.uri)" v-if="value.type === 99" class="attachment-archive attachment-other">
                      <span>Arquivo</span>
                      <a :href="value.uri" target="_blank">Visualizar</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="dataModal.isManager" class="col-sm-12 col-md-12 col-lg-12">
              <div class="solicitation-history">
                <div @click="refundHistoryContent()" class="title title-history">
                  <span>Histórico de alterações</span>
                  <ion-icon v-if="!arrowRefundsHistory" name="chevron-forward-outline"></ion-icon>
                  <ion-icon v-if="arrowRefundsHistory" name="chevron-down-outline"></ion-icon>
                </div>
              </div>
              <div v-if="arrowRefundsHistory" class="history-timeline">
                <div v-for="(value, index) in dataContentRefundsHistory" :class="{'is-admin' : value.admin}" class="col-sm-12 col-md-12 col-lg-12 history" :key="index">
                  <div v-if="value.type === 3" class="history-content">
                    <div class="history-title">
                      <label class="title-data">{{ value.createdAt | formatDateHours }}</label>
                      <span class="title-created">
                        Alterado por <span class="title-user">{{ value.userName }}</span>
                      </span>
                    </div>
                    <span v-for="(content, index) in value.newValues" v-html="content" class="history-html" :key="index"></span>
                  </div>
                  <div v-else class="history-content history-content-solo">
                    <div class="history-title">
                      <label class="title-data">{{ value.createdAt | formatDateHours }}</label>
                      <span class="title-created">
                        Reembolso <span :class="{'analysis' : value.newValues == 'Em análise',
                                                 'pending' : value.newValues == 'Pendente',
                                                 'approved' : value.newValues == 'Aprovado',
                                                 'refused' : value.newValues == 'Recusado'}"
                                        class="title-status">{{ value.newValues }}</span>
                        por <span class="title-user">{{ value.userName }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="line-content">
                    <span class="circle-point"></span>
                  </div>
                  <div class="line-content">
                    <span class="circle-point"></span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="dataModal.isManager" class="col-sm-12 col-md-12 col-lg-12">
              <div class="solicitation-evaluate">
                <span class="title title-modal">Avalie a solicitação
                  <span v-if="dataContentRefundsEmployee[0].userRefundStatus === 0" class="tag-uninformed">Não informado</span>
                  <span v-if="dataContentRefundsEmployee[0].userRefundStatus === 1" class="tag-pending">Pendente</span>
                  <span v-if="dataContentRefundsEmployee[0].userRefundStatus === 4" class="tag-analysis">Em análise</span>
                  <span v-if="dataContentRefundsEmployee[0].userRefundStatus === 2 && dataContentRefundsEmployee[0].userRefundStatusPayment !== 2" class="tag-approved tag-approved-modal">Aprovado</span>
                  <span v-if="dataContentRefundsEmployee[0].userRefundStatus === 3" class="tag-refused">Recusado</span>
                  <div v-if="dataContentRefundsEmployee[0].userRefundStatus === 2 && dataContentRefundsEmployee[0].userRefundStatusPayment === 1" class="tag-card tag-card-solo">
                    <span class="pay-card paid-solo">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5 6C10.5 3.51562 8.48438 1.5 6 1.5C3.51562 1.5 1.5 3.51562 1.5 6C1.5 8.48438 3.51562 10.5 6 10.5C8.48438 10.5 10.5 8.48438 10.5 6Z" stroke="#2ACC6B" stroke-width="0.75" stroke-miterlimit="10"/>
                        <path d="M8.25 4.125L5.1 7.875L3.75 6.375" stroke="#2ACC6B" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      Pago
                    </span>
                  </div>
                  <div v-if="dataContentRefundsEmployee[0].userRefundStatus === 2 && dataContentRefundsEmployee[0].userRefundStatusPayment === 2" class="tag-card">
                    <span class="pay-card">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5 6C10.5 3.51562 8.48438 1.5 6 1.5C3.51562 1.5 1.5 3.51562 1.5 6C1.5 8.48438 3.51562 10.5 6 10.5C8.48438 10.5 10.5 8.48438 10.5 6Z" stroke="#2ACC6B" stroke-width="0.75" stroke-miterlimit="10"/>
                        <path d="M8.25 4.125L5.1 7.875L3.75 6.375" stroke="#2ACC6B" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      Pago no cartão MarQ.
                    </span>
                  </div>
                </span>
                <div v-if="dataContentRefundsEmployee[0].userRefundStatusPayment !== 2" class="select-situation">
                  <label>Alterar situação <span>*</span></label>
                  <select v-model="evaluateRequest">
                    <option value="1">Pendente</option>
                    <option value="2">Aprovado</option>
                    <option value="3">Recusado</option>
                    <option value="4">Em análise</option>
                    <option value="5">Pago</option>
                  </select>
                  <div v-if="evaluateRequest == '3'">
                    <label>Motivo da recusa <span>*</span></label>
                    <textarea v-model="reasonRefuse" maxlength="244" placeholder="Digite aqui"/>
                  </div>
                </div>
                <div v-if="dataContentRefundsEmployee[0].userRefundStatusPayment !== 2" class="checkbox">
                  <input id="sendEmailCheckbox" type="checkbox">
                  <label>Enviar notificação por e-mail</label>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12">
              <div v-if="dataModal.isManager" class="solicitation-btn">
                <span v-if="validateFormRefunds" class="form-error">Preencha todos os campos com *</span>
                <button v-if="dataContentRefundsEmployee[0].userRefundStatusPayment !== 2" :disabled="loadingChanges" @click="saveChangesRefunds()" class="btn-save">
                  <span v-if="!loadingChanges">Salvar alterações</span>
                  <div class="loading-btn" v-else>
                    <div class="spinner-btn">
                      <div class="rect1"></div>
                      <div class="rect2"></div>
                      <div class="rect3"></div>
                      <div class="rect4"></div>
                      <div class="rect5"></div>
                    </div>
                  </div>
                </button>
                <span @click="closeModal()" :class="{'margin-top-approved' : dataContentRefundsEmployee[0].userRefundStatusPayment === 2}" class="btn-close">Fechar</span>
                <span v-if="dataContentRefundsEmployee[0].userRefundStatusPayment === 2" class="paid-card-marq">Solicitações de reembolso já pagas no Cartão MarQ. não podem ser alteradas.</span>
              </div>
              <div v-else class="solicitation-btn offset-top-30">
                <div v-if="dataContentRefundsEmployee[0].userRefundStatus === 3" class="solicitation-btn">
                  <span @click="reopenRefundRefused()" class="btn-reopen">
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.1665 17.5L19.6665 10L2.1665 2.5V8.33333L14.6665 10L2.1665 11.6667V17.5Z" fill="#352DA5"/>
                    </svg>
                    Reabrir solicitação
                  </span>
                </div>
                <span @click="closeModal()" class="btn-close">Fechar</span>
              </div>
            </div>
          </div>
          <div v-if="isDetail && $props.solicitationTeam && !loading" class="row is-solicitation-view">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <div class="solicitation-user">
                <img v-if="dataContentRefundsManager[0].photoUri !== null || ''" :src="dataContentRefundsManager[0].photoUri" alt="Foto" />
                <img v-else src="../../../assets/img/user-default.png" alt="Foto" />
                <span class="name">{{ dataContentRefundsManager[0].name }}</span>
                <span class="office">{{ dataContentRefundsManager[0].officeName }}</span>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
              <div class="solicitation-status">
                <span class="title">Detalhes do reembolso</span>
                <span class="value">Valor: <span>{{ dataContentRefundsManager[0].value | formatMoney }}</span></span>
                <span class="status">Status:</span>
                <span v-if="dataContentRefundsManager[0].userRefundStatus === 0" class="tag-uninformed">Não informado</span>
                <span v-if="dataContentRefundsManager[0].userRefundStatus === 1" class="tag-pending">Pendente</span>
                <span v-if="dataContentRefundsManager[0].userRefundStatus === 4" class="tag-analysis">Em análise</span>
                <span v-if="dataContentRefundsManager[0].userRefundStatus === 2" class="tag-approved">Aprovado</span>
                <span v-if="dataContentRefundsManager[0].userRefundStatus === 3" class="tag-refused">Recusado</span>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12">
              <div class="solicitation-details">
                <span class="title">Detalhes do Reembolso</span>
                <span class="requested">Solicitado em: <span>{{ dataContentRefundsManager[0].requestedAt | formatDate }}</span></span>
                <span class="expense">Data da despesa: <span>{{ dataContentRefundsManager[0].expenseDate | formatDate }}</span> </span>
                <span class="value">Valor: <span>{{ dataContentRefundsManager[0].value | formatMoney }}</span></span>
                <span class="category">Categoria: <span>{{ dataContentRefundsManager[0].refundCategory }}</span></span>
                <span class="obs">Observação: <span>{{ dataContentRefundsManager[0].message }}</span></span>
                <span v-if="dataContentRefundsManager[0].userRefundStatus === 3" class="obs">Motivo da recusa: <span>{{ dataContentRefundsManager[0].deniedMotive }}</span></span>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12">
              <div class="solicitation-attachments">
                <span class="title">Anexos:</span>
                <svg class="d-none" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.8334 7.5H12.5V2.5H7.50004V7.5H4.16671L10 14.1667L15.8334 7.5ZM3.33337 15.8333H16.6667V17.5H3.33337V15.8333Z" fill="#2F23D6"/>
                </svg>
                <div class="attachments">
                  <div v-for="(value, index) in dataContentRefundsManager[0].attachments" class="group-attachments" :key="index">
                    <a v-if="value.type === 0" :href="value.uri" target="_blank">
                      <img  class="attachment-img" :src="value.uri" alt="Anexo"/>
                    </a>
                    <a v-if="value.type === 1" :href="value.uri" target="_blank">
                      <img  class="attachment-img" :src="value.uri" alt="Anexo"/>
                    </a>
                    <div @click="openDocument(value.uri)" v-if="value.type === 2" class="attachment-archive attachment-pdf">
                      <span>Arquivo PDF</span>
                      <a :href="value.uri" target="_blank">Visualizar</a>
                    </div>
                    <div @click="openDocument(value.uri)" v-if="value.type === 3" class="attachment-archive attachment-doc">
                      <span>Documento</span>
                      <a :href="value.uri" target="_blank">Visualizar</a>
                    </div>
                    <div @click="openDocument(value.uri)" v-if="value.type === 4" class="attachment-archive attachment-zip">
                      <span>Arquivo ZIP</span>
                      <a :href="value.uri" target="_blank">Visualizar</a>
                    </div>
                    <div @click="openDocument(value.uri)" v-if="value.type === 99" class="attachment-archive attachment-other">
                      <span>Arquivo</span>
                      <a :href="value.uri" target="_blank">Visualizar</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="dataModal.isManager" class="col-sm-12 col-md-12 col-lg-12">
              <div class="solicitation-history">
                <div @click="refundHistoryContent()" class="title title-history">
                  <span>Histórico de alterações</span>
                  <ion-icon v-if="!arrowRefundsHistory" name="chevron-forward-outline"></ion-icon>
                  <ion-icon v-if="arrowRefundsHistory" name="chevron-down-outline"></ion-icon>
                </div>
              </div>
              <div v-if="arrowRefundsHistory" class="history-timeline">
                <div v-for="(value, index) in dataContentRefundsHistory" :class="{'is-admin' : value.admin}" class="col-sm-12 col-md-12 col-lg-12 history" :key="index">
                  <div v-if="value.type === 3" class="history-content">
                    <div class="history-title">
                      <label class="title-data">{{ value.createdAt | formatDateHours }}</label>
                      <span class="title-created">
                        Alterado por <span class="title-user">{{ value.userName }}</span>
                      </span>
                    </div>
                    <span v-for="(content, index) in value.newValues" v-html="content" class="history-html"></span>
                  </div>
                  <div v-else class="history-content history-content-solo">
                    <div class="history-title">
                      <label class="title-data">{{ value.createdAt | formatDateHours }}</label>
                      <span class="title-created">
                        Reembolso <span :class="{'analysis' : value.newValues == 'Em análise',
                                                 'pending' : value.newValues == 'Pendente',
                                                 'approved' : value.newValues == 'Aprovado',
                                                 'refused' : value.newValues == 'Recusado'}"
                                        class="title-status">{{ value.newValues }}</span>
                        por <span class="title-user">{{ value.userName }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="line-content">
                    <span class="circle-point"></span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="dataModal.isManager" class="col-sm-12 col-md-12 col-lg-12">
              <div class="solicitation-evaluate">
                <span class="title title-modal">Avalie a solicitação
                  <span v-if="dataContentRefundsManager[0].userRefundStatus === 0" class="tag-uninformed">Não informado</span>
                  <span v-if="dataContentRefundsManager[0].userRefundStatus === 1" class="tag-pending">Pendente</span>
                  <span v-if="dataContentRefundsManager[0].userRefundStatus === 4" class="tag-analysis">Em análise</span>
                  <span v-if="dataContentRefundsManager[0].userRefundStatus === 2 && dataContentRefundsManager[0].userRefundStatusPayment !== 2" class="tag-approved tag-approved-modal">Aprovado</span>
                  <span v-if="dataContentRefundsManager[0].userRefundStatus === 3" class="tag-refused">Recusado</span>
                  <div v-if="dataContentRefundsManager[0].userRefundStatus === 2 && dataContentRefundsManager[0].userRefundStatusPayment === 1" class="tag-card tag-card-solo">
                    <span class="pay-card paid-solo">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5 6C10.5 3.51562 8.48438 1.5 6 1.5C3.51562 1.5 1.5 3.51562 1.5 6C1.5 8.48438 3.51562 10.5 6 10.5C8.48438 10.5 10.5 8.48438 10.5 6Z" stroke="#2ACC6B" stroke-width="0.75" stroke-miterlimit="10"/>
                        <path d="M8.25 4.125L5.1 7.875L3.75 6.375" stroke="#2ACC6B" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      Pago
                    </span>
                  </div>
                  <div v-if="dataContentRefundsManager[0].userRefundStatus === 2 && dataContentRefundsManager[0].userRefundStatusPayment === 2" class="tag-card">
                    <span class="pay-card">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5 6C10.5 3.51562 8.48438 1.5 6 1.5C3.51562 1.5 1.5 3.51562 1.5 6C1.5 8.48438 3.51562 10.5 6 10.5C8.48438 10.5 10.5 8.48438 10.5 6Z" stroke="#2ACC6B" stroke-width="0.75" stroke-miterlimit="10"/>
                        <path d="M8.25 4.125L5.1 7.875L3.75 6.375" stroke="#2ACC6B" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      Pago no cartão MarQ.
                    </span>
                  </div>
                </span>
                <div v-if="dataContentRefundsManager[0].userRefundStatusPayment !== 2" class="select-situation">
                  <label>Alterar situação <span>*</span></label>
                  <select v-model="evaluateRequest">
                    <option value="1">Pendente</option>
                    <option value="2">Aprovado</option>
                    <option value="3">Recusado</option>
                    <option value="4">Em análise</option>
                    <option value="5">Pago</option>
                  </select>
                  <div v-if="evaluateRequest == '3'">
                    <label>Motivo da recusa <span>*</span></label>
                    <textarea v-model="reasonRefuse" maxlength="244" placeholder="Digite aqui"/>
                  </div>
                </div>
                <div v-if="dataContentRefundsManager[0].userRefundStatusPayment !== 2" class="checkbox">
                  <input id="sendEmailCheckbox" type="checkbox">
                  <label>Enviar notificação por e-mail</label>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12">
              <div v-if="dataModal.isManager" class="solicitation-btn">
                <span v-if="validateFormRefunds" class="form-error">Preencha todos os campos com *</span>
                <button v-if="dataContentRefundsManager[0].userRefundStatusPayment !== 2" :disabled="loadingChanges" @click="saveChangesRefunds()" class="btn-save">
                  <span v-if="!loadingChanges">Salvar alterações</span>
                  <div class="loading-btn" v-else>
                    <div class="spinner-btn">
                      <div class="rect1"></div>
                      <div class="rect2"></div>
                      <div class="rect3"></div>
                      <div class="rect4"></div>
                      <div class="rect5"></div>
                    </div>
                  </div>
                </button>
                <span @click="closeModal()" :class="{'margin-top-approved' : dataContentRefundsManager[0].userRefundStatusPayment === 2}" class="btn-close">Fechar</span>
                <span v-if="dataContentRefundsManager[0].userRefundStatusPayment === 2" class="paid-card-marq">Solicitações de reembolso já pagas no Cartão MarQ. não podem ser alteradas.</span>
              </div>
              <div @click="closeModal()" v-else class="solicitation-btn offset-top-30">
                <span class="btn-close">Fechar</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Autocomplete from "vue2-autocomplete-js";
import {
  CHANGE_STATUS_REFUNDS, DOCUMENT_UPLOAD,
  EXPENSE_CATEGORY, REFUND_HISTORY, REFUNDS_COLLABORATOR, REFUNDS_MANAGER,
  REQUEST_REFUNDS,
} from "../../../urlConfig";
import { VueEditor, Quill } from "vue2-editor";
import swal from "sweetalert";
import progressLoading from "../components/progressLoading";
import {REQUEST_SERVICE} from "../../../requestConfig";
import {UTIL_SERVICE} from "../../../utils";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from "vuejs-datepicker";
import {VMoney} from 'v-money'

import moment from "moment";

export default {
  name: "modal-refunds",
  components: {
    Autocomplete,
    progressLoading,
    VueEditor,
    datepicker,
    Quill
  },
  props: {
    dataModal: {
      required: true
    },
    solicitationRefundId: {
      required: false
    },
    solicitationTeam: {
      required: false
    },
    // runFunction: (contentFunction) => {
    //   return contentFunction
    // },
  },
  directives: {money: VMoney},
  watch: {
    emitValue : function(val){
      this.$emit('update:actionReload', val)
    },
    dataModal: function (val) {
      this.isCreate = false;
      this.isDetail = false;
      this.isManager = ''

      switch(val.modalType) {
        case 1:
          this.isCreate = true;
          this.requestRefundForm.refundDate = new Date();
          this.expenseContentModal();
          this.addInputAttach();
          break;
        case 2:
          this.isDetail = true;
          this.expenseContentModal()
          break;
        case 3:
          this.isCreate = true;
          this.expenseContentModal();
          break;
      }
    }
  },
  data() {
    return {
      emitValue: {
        loading: '',
        random: ''
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false,
      },
      ptBR: ptBR,
      loadingSolicitation: false,
      loading: false,
      loadingChanges: false,
      width: '700px',
      isCreate: false,
      isDetail: false,
      isManager: '',
      uploadStage: [],
      files: [],
      evaluateRequest: '',
      categories: '',
      attachments: [],
      arrowRefundsHistory: false,
      totalAttachments: [],
      totalCountAttachments: 0,
      descriptionCategory: '',
      requestRefundForm: {
        refundDate: '',
        refundValue: '',
        refundCategory: '',
        refundObs: '',
        refundAttachments: [],
      },
      validateForm: false,
      validateFormRefunds: false,
      sendEmailRefund: false,
      reasonRefuse: '',
      countRequestRefundsHistory: 0,
      dataContentRefundsManager: '',
      dataContentRefundsEmployee: '',
      dataContentRefundsHistory: '',
    }
  },
  methods: {
    openDocument(url) {
      window.open(url);
    },
    customFormatter(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    closeModalHeader() {
      this.clearForm();
    },
    closeModal() {
      $('#modalRefunds').modal('toggle');
      $('.modal-backdrop').remove();

      this.clearChangesRefunds();
      this.clearForm();
    },
    changeDescriptionCategory() {
      this.descriptionCategory = this.categories.find(x => x.id === this.requestRefundForm.refundCategory)
    },
    attachFile(id) {
      $(id).click();
    },
    addInputAttach() {

      $('#documentFileRefunds0').removeAttr('disabled')
      this.totalCountAttachments++;

      if(this.totalCountAttachments > 4) {
        return
      }

      $(".add-attach").css("display", "block")


      this.totalAttachments.push({
        'attach': this.totalCountAttachments
      })

      this.uploadStage.push({
        'status': ''
      })

      this.attachments.push({
        'name': ''
      })
    },
    removeAttachSplice(index) {
      this.attachments.splice(index, 1)
    },
    removeInputAttach(index) {
      this.totalCountAttachments--;
      this.totalAttachments.splice(index, 1)
      this.uploadStage.splice(index, 1)
      this.requestRefundForm.refundAttachments = this.requestRefundForm.refundAttachments.filter((obj) => obj.uri !== this.attachments[index].uri);
      this.removeAttachSplice(index);
    },
    uploadDocument(file, index) {
      let type = 0
      const id = '#documentFileRefunds' + index
      $(id).attr('disabled', 'true')

      this.uploadStage[index].status = "loading";
      this.attachments[index].name = file.name;


      switch (true) {
        case file.type.includes("/png"):
        case file.type.includes("/jpeg"):
        case file.type.includes("/webp"):
          type = 1;
          break
        case file.type.includes("/pdf"):
          type = 2;
          break
        case file.type.includes("/docx"):
          type = 3;
          break
        case file.type.includes("/zip"):
          type = 4;
          break
        default:
          type = 99;
          break
      }

      if (this.requestRefundForm.refundAttachments.length < 0) {
        type = 0
      }

        REQUEST_SERVICE.fileUpload(DOCUMENT_UPLOAD, file).then((response) => {
      UTIL_SERVICE.console("RESULT UPLOAD DOCUMENT: ", response);

        this.attachments[index].uri = response.data
        this.requestRefundForm.refundAttachments.push(
          {
            "uri": response.data,
            "type": type,
            "fileName": file.name
          }
        )

        this.uploadStage[index].status = "success";

      }).catch(reason => {
        console.log(reason)
        $(id).removeAttr('disabled')
        this.uploadStage[index].status = "fail";
      });
    },
    previewFiles(index) {
      this.files = this.$refs.myFiles[index].files;

      if (this.files.length) {
        if (this.files[0].size <= 3597152) {
          this.uploadDocument(this.files[0], index)
        } else {
          swal("Aviso", "Não foi possivel realizar o envio da imagem.\n\n Motivo: arquivo muito grande por favor enviar um arquivo menor que 3.5MB.", "warning");
        }
      }
    },
    expenseContentModal() {
      const filterDate = '?initDate=' + this.$route.params.dateInit + '&endDate=' + this.$route.params.dateEnd + '&r=1000'

      if(this.isDetail) {
        this.loading = true;

        if(this.dataModal.isManager) {
          REQUEST_SERVICE.get(REFUNDS_MANAGER + filterDate).then((response) => {
            UTIL_SERVICE.console("RESULT REFUNDS_MANAGER:", response.data);

            this.dataContentRefundsManager = response.data.items.filter((obj) => obj.id === this.$props.solicitationRefundId);
            this.evaluateRequest = this.dataContentRefundsManager[0].userRefundStatus
            this.loading = false;

          }).catch(reason => {
            this.loading = false;
          });

          REQUEST_SERVICE.get(REFUNDS_COLLABORATOR + filterDate).then((response) => {
            UTIL_SERVICE.console("RESULT REFUNDS_COLLABORATOR:", response.data);

            this.dataContentRefundsEmployee = response.data.items.filter((obj) => obj.id === this.$props.solicitationRefundId);
            this.evaluateRequest = this.dataContentRefundsEmployee[0].userRefundStatus
            this.loading = false;

          }).catch(reason => {
            this.loading = false;
          });

          REQUEST_SERVICE.get(REFUND_HISTORY + this.$props.solicitationRefundId).then((response) => {
            UTIL_SERVICE.console("RESULT REFUND_HISTORY:", response.data);
            this.dataContentRefundsHistory = response.data
            this.dataContentRefundsHistory = this.dataContentRefundsHistory.reverse()

          }).catch(reason => {
            console.log(reason)
          });
        }

        if(!this.dataModal.isManager) {
          REQUEST_SERVICE.get(REFUNDS_COLLABORATOR + filterDate).then((response) => {
            UTIL_SERVICE.console("RESULT REFUNDS_COLLABORATOR:", response.data);

            this.dataContentRefundsEmployee = response.data.items.filter((obj) => obj.id === this.$props.solicitationRefundId);
            this.loading = false;

          }).catch(reason => {
            this.loading = false;
          });
        }

        return
      }

      if(this.isCreate) {
        this.getCategory();
      }
    },
    getCategory(value) {
      REQUEST_SERVICE.get(EXPENSE_CATEGORY).then((response) => {
        UTIL_SERVICE.console("RESULT EXPENSE_CATEGORY:", response.data);
        this.categories = response.data;

        if(value === 1) {
          this.descriptionCategory = this.categories.find(x => x.id === this.requestRefundForm.refundCategory)
        }
      }).catch(reason => {
        console.log(reason)
      });
    },
    clearForm() {
      this.attachments = []
      this.totalAttachments = []
      this.totalCountAttachments = 0
      this.requestRefundForm.refundDate = new Date();
      this.requestRefundForm.refundValue = ''
      this.requestRefundForm.refundCategory = ''
      this.requestRefundForm.refundObs = ''
      this.requestRefundForm.refundAttachments = []
      this.uploadStage = []
      this.countRequestRefundsHistory = 0
      this.descriptionCategory = ''
      this.arrowRefundsHistory = false
    },
    clearChangesRefunds() {
      this.reasonRefuse = ''
      this.sendEmailRefund = false
      this.arrowRefundsHistory = false
      this.countRequestRefundsHistory = 0
    },
    requestNewRefund() {

      if(!this.requestRefundForm.refundDate ||
        !this.requestRefundForm.refundValue ||
        !this.requestRefundForm.refundCategory) {
        return this.validateForm = true
      }

      if(this.requestRefundForm.refundValue === 'R$ 0,00') {
        return this.validateForm = true
      }

      if(this.attachments.length > 0) {
        if(!this.requestRefundForm.refundAttachments.length > 0) {
          return this.validateForm = true
        }
      }

      this.validateForm = false
      this.loadingSolicitation = !this.loadingSolicitation

      const dateFormated = moment(this.requestRefundForm.refundDate).format('YYYY-MM-DD 12:00:00');
      const moneyEnum = this.requestRefundForm.refundValue.replace(/[^0-9]/g, '');
      const moneySubstringInitial = moneyEnum.slice(0, -2);
      const moneySubstringFinal = moneyEnum.substr(-2);
      const moneyFormated = moneySubstringInitial + '.' + moneySubstringFinal;

      let obj = {
        expenseDate : dateFormated,
        value: moneyFormated,
        refundCategoryId: this.requestRefundForm.refundCategory,
        message: this.requestRefundForm.refundObs,
        attachments: this.requestRefundForm.refundAttachments,
      }

      REQUEST_SERVICE.post(REQUEST_REFUNDS, obj).then((response) => {
        UTIL_SERVICE.console("RESULT REQUEST_REFUNDS:", response.data);

        $('#modalRefunds').modal('toggle');
        swal('Sucesso', response.data, 'success')
        this.clearForm();
        // this.runFunction();
        this.loadingSolicitation = !this.loadingSolicitation
        this.emitValue = {loading: this.loadingSolicitation, random: Math.floor(Math.random() * 500)};

      }).catch(reason => {
        swal('Aviso', "Falha ao solicitar reembolso!", 'error')
        this.loadingSolicitation = false;
      });
    },
    saveChangesRefunds() {

      if(!this.$props.solicitationRefundId ||
        !this.evaluateRequest) {
        return this.validateFormRefunds = true
      }

      if(this.evaluateRequest == 3) {
        if(!this.reasonRefuse) {
          return this.validateFormRefunds = true
        }
      }

      this.loadingChanges = true

      if($('#sendEmailCheckbox').is(':checked')) {
        this.sendEmailRefund = true
      }

      let obj = {
        id: this.$props.solicitationRefundId,
        reason: this.reasonRefuse,
        userRefundStatus: Number(this.evaluateRequest),
        sendEmail: this.sendEmailRefund
      }

      if(this.evaluateRequest == 5) {
        obj.userRefundStatusPayment = 1
        obj.userRefundStatus = 2
      }

      REQUEST_SERVICE.put(CHANGE_STATUS_REFUNDS, obj).then((response) => {
        UTIL_SERVICE.console("RESULT CHANGE_STATUS_REFUNDS:", response.data);

        $('#modalRefunds').modal('toggle');
        swal('Sucesso', response.data, 'success')

        this.clearChangesRefunds();
        // this.runFunction();
        this.loadingChanges = false;
        this.emitValue = {loading: this.loadingSolicitation, random: Math.floor(Math.random() * 500)};

      }).catch(reason => {
        this.clearChangesRefunds();
        swal('Aviso', "Falha ao tentar salvar as alterações!", 'error')
        this.loadingChanges = false;
      });
    },
    reopenRefundRefused() {
      this.clearForm();

      let obj = []

      for (const value in this.dataContentRefundsEmployee[0].attachments) {
        this.totalCountAttachments++;

        this.totalAttachments.push({
          'attach': this.totalCountAttachments
        })

        this.uploadStage.push({
          'status': 'success'
        })

        obj.push({
          name: this.dataContentRefundsEmployee[0].attachments[value].filename,
          uri: this.dataContentRefundsEmployee[0].attachments[value].uri
        })
      }

      this.attachments = obj
      this.requestRefundForm.refundCategory = this.dataContentRefundsEmployee[0].refundCategoryId;
      this.requestRefundForm.refundDate = new Date(this.dataContentRefundsEmployee[0].expenseDate);
      this.requestRefundForm.refundValue = this.dataContentRefundsEmployee[0].value;
      this.requestRefundForm.refundAttachments = this.dataContentRefundsEmployee[0].attachments;
      this.requestRefundForm.refundObs = this.dataContentRefundsEmployee[0].message;

      $('#openRequestRefundAgain').click();
      this.getCategory(1);
    },
    refundHistoryContent(){
      this.arrowRefundsHistory = !this.arrowRefundsHistory
    }
  }
}
</script>

<style lang="scss">
.anonymous {
  position: relative;
  top: 10px;
}

.m-top-0 {
  margin-top: 10px !important;
}

.title-history {
  cursor: pointer;
}

.motive-txt {
  font-family: 'Montserrat', sans-serif !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: var(--titleBox) !important;
}
.double-btn {
  padding: 0 15px 0 15px;
  .form-error {
    position: absolute;
    left: 120px;
    bottom: 37px;

    color: var(--redColor);

    @media only screen and (max-width: 767px) {
      left: 30px;
    }

    @media only screen and (max-width: 660px) {
      right: 30px;
      bottom: 72px;
    }
  }

  .btn-submit {
    &:disabled {
      filter: grayscale(1);
    }
  }
}




.refund-date {
  position: absolute;
  left: 23px;
  width: 21px;
  bottom: 6px;
  fill: var(--titleBox);
  pointer-events: none;
}

.vdp-datepicker {
  input {
    cursor: pointer;
    padding-left: 38px !important;
  }

  .vdp-datepicker__calendar {
    position: absolute;
    left: 10px;
    top: 32px;
  }

  @media only screen and (max-device-width: 420px) {
    display: block;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}

.select-input {
  width: 100%;
  margin-bottom: 30px;

  label {
    display: block;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #7F8897;
  }

  select {
    width: 100%;
    height: 36px;
    padding: 6px 12px;
    background-color: #fff;
    border: 1px solid #c2cad8;
    border-radius: 4px;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  }
}

@media only screen and (max-width: 767px) {
 .modal-dialog {
   margin: 30px auto !important;
   width: 90% !important;
 }
}

.margin-top-approved {
  margin-top: 30px;
  margin-bottom: 20px;
}

.title-modal {
  position: relative;

  .tag-card {
    position: absolute;
    top: 0;
    left: 190px;

    .pay-card {
      display: flex;
      align-items: center;
      justify-content: center;
      width: max-content;

      color: var(--textSide);
      font-size: 15px !important;
      font-weight: 400;
      margin-top: 0 !important;
      margin-left: 0 !important;

      svg {
        width: 15px;
        height: 15px;
        margin-right: 3px;
      }
    }

    @media only screen and (max-width: 500px) {
      left: -1px;
      top: 20px;
    }
  }

  .tag-card-solo {
    left: 310px;

    @media only screen and (max-width: 500px) {
      left: 222px;
      top: 25px;
    }

    @media only screen and (max-width: 405px) {
      left: 120px;
      top: 27px;
    }
  }
}

.paid-card-marq {
  text-align: center;
  font-size: 15px;
  font-weight: 400;
  color: var(--defaultText);
  width: 90%;
  margin: auto;
}

.tag-approved-modal {
  @media only screen and (max-width: 405px) {
    margin-left: 0 !important;
    margin-right: 13px;
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/views/modals/modalRefunds.vue